/**
 * Mobile carousel affordances.
 *
 *   gallery sections     -> one pagination dot per item
 *   text-with-icons rows -> a "swipe" label, when the section sets one
 *
 * Both are CSS scroll-snap tracks; the theme ships no dots or hints of
 * its own. Styles live in vaverto-custom.css and only appear below
 * 768px. No-ops on pages without those sections.
 *
 * Nothing here holds copy: the swipe wording comes from the section's
 * "Swipe hint" setting via data-swipe-hint, so it stays editable in the
 * theme editor.
 */
(function () {
  var ARROW =
    '<svg viewBox="0 0 26 9" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M0.5 4.5h24M21 1l3.5 3.5L21 8" stroke="currentColor" ' +
    'stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* Works for any one-at-a-time track: the caller names the track and the
   * item, so the gallery and the icon row share one implementation. */
  function addDots(section, trackSelector, itemSelector) {
    var track = section.querySelector(trackSelector);
    if (!track) return;

    var items = Array.prototype.slice.call(track.querySelectorAll(itemSelector));
    if (items.length < 2) return;

    var nav = document.createElement('div');
    nav.className = 'vv-reels-dots';
    nav.setAttribute('role', 'tablist');

    var dots = items.map(function (item, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('role', 'tab');
      // name the dot after the slide's own heading where there is one, so a
      // screen reader announces something more useful than a position
      var heading = item.querySelector('h2, h3, h4, [class*="heading"]');
      var label = heading && heading.textContent.trim();
      dot.setAttribute('aria-label', label || 'Item ' + (index + 1));
      dot.addEventListener('click', function () {
        track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      nav.appendChild(dot);
      return dot;
    });

    track.parentNode.appendChild(nav);

    onScroll(track, function () {
      var active = activeIndex(track, items);
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === active);
        dot.setAttribute('aria-selected', i === active ? 'true' : 'false');
      });
    });
  }

  function addSwipeHint(track) {
    var label = track.getAttribute('data-swipe-hint');
    if (!label) return;
    if (track.querySelectorAll('.text-with-icons__block').length < 2) return;

    var hint = document.createElement('p');
    hint.className = 'vv-swipe-hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.appendChild(document.createTextNode(label));
    hint.insertAdjacentHTML('beforeend', ARROW);

    track.parentNode.appendChild(hint);
  }

  function activeIndex(track, items) {
    var middle = track.scrollLeft + track.clientWidth / 2;

    for (var i = 0; i < items.length; i++) {
      var left = items[i].offsetLeft - track.offsetLeft;
      if (middle >= left && middle < left + items[i].offsetWidth) return i;
    }
    return 0;
  }

  function onScroll(track, handler) {
    var queued = false;

    track.addEventListener(
      'scroll',
      function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () {
          queued = false;
          handler();
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', handler);
    handler();
  }

  /**
   * The theme renders the product title and the price inside one block, so
   * a template block can only ever land after both. This lifts the rating
   * into that container, between the two. If it never runs, the rating
   * simply stays just below the price.
   */
  function placeRating() {
    var rating = document.querySelector('.vv-rating');
    if (!rating) return;

    var container = document.querySelector('.thb-product-detail .product-title-container');
    if (!container) return;

    var price = container.querySelector('.product-price-container');
    if (!price) return;

    container.insertBefore(rating, price);
  }

  /**
   * Keeps the discount pill in step with the selected variant.
   *
   * The theme only re-renders the price container on a variant change, and
   * it rewrites the URL with ?variant=<id> as it does so. Watching that
   * container therefore gives a reliable signal, and the URL gives the id.
   * Figures come from the block's published per-variant map, never from
   * parsing prices out of the DOM.
   */
  function syncDiscountBadge() {
    var pill = document.querySelector('.vv-badge--discount');
    if (!pill) return;

    var holder = pill.parentNode.querySelector('.vv-badges__data');
    var price = document.querySelector('[id^="price-"]');
    if (!holder || !price) return;

    var data;
    try {
      data = JSON.parse(holder.textContent);
    } catch (e) {
      return;
    }

    var label = pill.getAttribute('data-label') || '[amount] OFF';

    function apply() {
      var id = new URLSearchParams(window.location.search).get('variant') || data.default;
      var amount = data.variants[id];

      if (amount) {
        pill.textContent = label.replace('[amount]', amount);
        pill.hidden = false;
      } else {
        pill.hidden = true;
      }
    }

    new window.MutationObserver(apply).observe(price, { childList: true, subtree: true });
    apply();
  }

  function boot() {
    // Both selectors follow section settings, not section ids, so renaming
    // or duplicating a section keeps these working.
    Array.prototype.forEach.call(document.querySelectorAll('.gallery--mobile-single'), function (el) {
      addDots(el, '.gallery--inner', '.gallery--item');
    });
    Array.prototype.forEach.call(document.querySelectorAll('.text-with-icons--mobile-single'), function (el) {
      addDots(el, '.text-with-icons__inner', '.text-with-icons__block');
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-swipe-hint]'), addSwipeHint);
    placeRating();
    syncDiscountBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
